module.exports = __WEBPACK_EXTERNAL_MODULE_150__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/add/operator/switchMap","commonjs2":"rxjs/add/operator/switchMap","amd":"rxjs/add/operator/switchMap"}
// module id = 150
// module chunks = 0 1